module.exports = "/_next/static/images/e6c2ef2707648ca9b4c36093034f6c2f-10-million-purple.svg";